var BORDER = "van-hairline";
var BORDER_TOP = "".concat(BORDER, "--top");
var BORDER_LEFT = "".concat(BORDER, "--left");
var BORDER_BOTTOM = "".concat(BORDER, "--bottom");
var BORDER_SURROUND = "".concat(BORDER, "--surround");
var BORDER_TOP_BOTTOM = "".concat(BORDER, "--top-bottom");
var BORDER_UNSET_TOP_BOTTOM = "".concat(BORDER, "-unset--top-bottom");
var HAPTICS_FEEDBACK = "van-haptics-feedback";
var FORM_KEY = Symbol("van-form");
export { BORDER, BORDER_BOTTOM, BORDER_LEFT, BORDER_SURROUND, BORDER_TOP, BORDER_TOP_BOTTOM, BORDER_UNSET_TOP_BOTTOM, FORM_KEY, HAPTICS_FEEDBACK };